export enum AddSiteItemId {
  EditPackage = 'editPackage',
  SelectableAffiliate = 'selectableAffiliate',
}
